import { useState } from "react";

interface NavItem {
  label: string;
  icon: string;
  children?: string[];
}

const navItems: NavItem[] = [
  { label: "Главное", icon: "ri-home-line" },
  { label: "Планирование", icon: "ri-calendar-line" },
  { label: "CRM и маркетинг", icon: "ri-contacts-line" },
  { label: "Продажи", icon: "ri-shopping-cart-line", children: [
    "Заказы клиентов",
    "Реализация товаров",
    "Счета на оплату",
    "Акты выполненных работ",
  ]},
  { label: "Закупки", icon: "ri-truck-line", children: [
    "Заказы поставщикам",
    "Поступление товаров",
  ]},
  { label: "Склад и доставка", icon: "ri-store-2-line", children: [
    "Остатки товаров",
    "Перемещения",
    "Инвентаризация",
  ]},
  { label: "Казначейство", icon: "ri-bank-card-line" },
  { label: "Финансовый результат и контроллинг", icon: "ri-line-chart-line" },
  { label: "НСИ и администрирование", icon: "ri-settings-3-line" },
];

const sectionIcons = [
  { label: "CRM", icon: "ri-customer-service-line" },
  { label: "Продажи", icon: "ri-shopping-cart-line" },
  { label: "Склад", icon: "ri-store-2-line" },
  { label: "Закупки", icon: "ri-truck-line" },
  { label: "Финансы", icon: "ri-bank-card-line" },
  { label: "Клиенты", icon: "ri-user-line" },
];

export default function OneSNavPanel() {
  const [expanded, setExpanded] = useState<Set<string>>(new Set(["Продажи"]));

  const toggleExpand = (label: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(label)) {
        next.delete(label);
      } else {
        next.add(label);
      }
      return next;
    });
  };

  return (
    <div className="w-[230px] flex-shrink-0 flex flex-col bg-[#FFFDF5] border-r border-[#D5CA8A] select-none h-full"
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      {/* Header */}
      <div className="h-[28px] flex items-center px-2 bg-[#FEF3C7] border-b border-[#D5CA8A]"
      >
        <span className="text-[11px] font-semibold text-[#2D2D2D] truncate">Методическая база</span>
      </div>

      {/* Section icons row */}
      <div className="flex items-center justify-around px-1 py-1 border-b border-[#D5CA8A] bg-[#FFFDF5]"
      >
        {sectionIcons.map((sec) => (
          <button
            key={sec.label}
            className="flex flex-col items-center gap-0.5 px-1 py-0.5 rounded hover:bg-[#FDF2B5] cursor-pointer transition-colors"
            title={sec.label}
          >
            <i className={`${sec.icon} text-[13px] text-[#666666]`}
            ></i>
            <span className="text-[8px] text-[#666666]"
            >{sec.label}</span>
          </button>
        ))}
      </div>

      {/* Nav items */}
      <div className="flex-1 overflow-y-auto py-1"
      >
        {navItems.map((item) => {
          const isExpanded = expanded.has(item.label);
          const isActive = item.label === "Продажи";
          return (
            <div key={item.label}>
              <button
                onClick={() => item.children && toggleExpand(item.label)}
                className={`w-full flex items-center gap-1.5 px-2 py-1 text-[11px] text-[#2D2D2D] transition-colors cursor-pointer ${
                  isActive ? "bg-[#FDF2B5]" : "hover:bg-[#FEF3C7]"
                }`}
              >
                {item.children && (
                  <i className={`ri-arrow-right-s-line text-[10px] text-[#666666] w-3 flex items-center justify-center transition-transform ${isExpanded ? "rotate-90" : ""}`}
                  ></i>
                )}
                {!item.children && <span className="w-3" />}
                <i className={`${item.icon} text-[12px] text-[#666666] w-4 h-4 flex items-center justify-center`}
                ></i>
                <span className="truncate">{item.label}</span>
              </button>

              {item.children && isExpanded && (
                <div className="pl-6">
                  {item.children.map((child) => (
                    <button
                      key={child}
                      className={`w-full text-left px-2 py-[2px] text-[11px] text-[#2D2D2D] transition-colors cursor-pointer ${
                        child === "Заказы клиентов" ? "bg-[#E8DB6C] font-medium" : "hover:bg-[#FEF3C7]"
                      }`}
                    >
                      {child}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}